import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { TranslocoModule } from '@ngneat/transloco';
import { NzRateModule } from 'ng-zorro-antd/rate';

import { ForgotpwComponent } from './components/forgotpw/forgotpw.component';
import { LoginComponent } from './components/login/login.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { SignupComponent } from './components/signup/signup.component';
import { ScheduleCalendarDayComponent } from './components/timeline-calendar/schedule-calendar-day/schedule-calendar-day.component';
import { ScheduleCalendarMonthComponent } from './components/timeline-calendar/schedule-calendar-month/schedule-calendar-month.component';
import { ScheduleCalendarWeekComponent } from './components/timeline-calendar/schedule-calendar-week/schedule-calendar-week.component';
import { KpsPipe } from './pipes/kps.pipe';
import { MomentDiffPipe } from './pipes/moment-diff.pipe';
import { MomentFormatPipe } from './pipes/moment-format.pipe';
import { NotifyTimePipe } from './pipes/notify-time.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { CurrencyRangeFormatPipe } from './pipes/currency-range-format.pipe';
import { MathExpressionMapperPipe } from './pipes/math-expression-mapper.pipe';
import { ShortViewContentPipe } from './pipes/short-view-content.pipe';
import { NgApexchartsModule } from 'ng-apexcharts';
import {LangSelectComponent} from './components/lang-select/lang-select.component';
import {EmbeddedFileViewerComponent} from './components/embedded-file-viewer/embedded-file-viewer.component';
import {SafeSrcPipe} from './pipes/safe-src.pipe';
import { NotePopupComponent } from './components/note-popup/note-popup.component';
import { ChatUserStatusPipe } from './pipes/chat-user-status.pipe';
import { NgOtpInputModule } from  'ng-otp-input';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import {RemoveWhitespaceCharsOnPasteDirective} from "./directives/remove-whitespace-chars-on-paste.directive";
const NzModules = [
  NzRateModule,
  NzIconModule,
  NzInputModule,
  NzButtonModule,
  NzBadgeModule,
  NzModalModule,
  NzFormModule,
  NzCheckboxModule,
  NzNotificationModule,
  NzAlertModule,
  NzDatePickerModule,
  NzSelectModule,
  NzDividerModule,
  NzProgressModule
];
@NgModule({
  declarations: [
    PageHeaderComponent,
    MomentFormatPipe,
    MomentDiffPipe,
    ScheduleCalendarDayComponent,
    ScheduleCalendarWeekComponent,
    ScheduleCalendarMonthComponent,
    LoginComponent,
    SignupComponent,
    SafeHtmlPipe,
    KpsPipe,
    NotifyTimePipe,
    ForgotpwComponent,
    CurrencyRangeFormatPipe,
    MathExpressionMapperPipe,
    ShortViewContentPipe,
    LangSelectComponent,
    EmbeddedFileViewerComponent,
    SafeSrcPipe,
    NotePopupComponent,
    ChatUserStatusPipe,
    RemoveWhitespaceCharsOnPasteDirective
  ],
  imports: [
    CommonModule,
    NzModules,
    TranslocoModule,
    ReactiveFormsModule,
    RouterModule,
    NgApexchartsModule,
    FormsModule,
    NgOtpInputModule
  ],
  exports: [
    PageHeaderComponent,
    MomentFormatPipe,
    MomentDiffPipe,
    ScheduleCalendarDayComponent,
    ScheduleCalendarWeekComponent,
    ScheduleCalendarMonthComponent,
    LoginComponent,
    SignupComponent,
    SafeHtmlPipe,
    KpsPipe,
    NotifyTimePipe,
    CurrencyRangeFormatPipe,
    MathExpressionMapperPipe,
    ShortViewContentPipe,
    NgApexchartsModule,
    LangSelectComponent,
    SafeSrcPipe,
    NotePopupComponent,
    ChatUserStatusPipe,
    RemoveWhitespaceCharsOnPasteDirective
  ]
})
export class SharedModule {}
